export default __webpack_public_path__ + "static/media/kidney.e5137b7d.svg";